<template>
  <div>
    <PageHeader title="Player Ratings"></PageHeader>
      <h3 v-if="playerRatings && playerRatings.length === 0">No players rated</h3>
      <v-container>
        <v-row>
          <v-col class="text-right">
            <router-link :to="{name: 'active-competitions'}">Competitions</router-link>
          </v-col>
        </v-row>
      </v-container>
      <v-card
        outlined
        v-for="playerRating in playerRatings" :key="playerRating.id"
        class="mb-4"
      >
        <v-container>
          <v-row>
            <v-col cols="2">
              <img :src="playerRating.photoUrl" :alt="playerRating.playerName" style="height: 35px;">
            </v-col>
            <v-col cols="5">
              <div>{{playerRating.name}}</div>
              <div class="small-text mt-1">{{playerRating.positionName}}</div>
            </v-col>
            <v-col cols="5" class="text-right pl-0" style="padding-top:20px;">
              <v-icon
                dark
                small
                color="orange"
                v-if="playerRating.rateAverage > 0"
              >
                mdi-star
              </v-icon>
              <v-icon
                dark
                small
                color="orange"
                v-if="playerRating.rateAverage > 1"
                class="star-left"
              >
                mdi-star
              </v-icon>
              <v-icon
                dark
                small
                color="orange"
                v-if="playerRating.rateAverage > 2"
                class="star-left"
              >
                mdi-star
              </v-icon>
              <v-icon
                dark
                small
                color="orange"
                v-if="playerRating.rateAverage > 3"
                class="star-left"
              >
                mdi-star
              </v-icon>
              <v-icon
                dark
                small
                color="orange"
                v-if="playerRating.rateAverage > 4"
                class="star-left"
              >
                mdi-star
              </v-icon>
               <span class="medium-text" style="margin-left: 5px;color:#ffffff;">({{playerRating.rateCount}})</span>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    <v-overlay
      :absolute="false"
      :value="overlay"
      :opacity="0.9"
      >
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import _ from 'lodash';

export default {
  name: 'playerratings',
  components: {
    PageHeader
  },
  data: () => ({
    overlay: false,
    playerRatings: null
  }),
  computed: {
    selectedCupId () {
      return this.$store.getters.selectedCupId;
    }
  },
  methods: {
    getPlayerRatings: function (slugParams) {
      this.overlay = true;
      var scope = this;
      this.$store.dispatch('getCustom', slugParams).then(response => {
        scope.playerRatings = [];
        _.forEach(response, (pr) => {
          if(_.find(scope.playerRatings, function(o) { return o.playerId === pr.playerId; }) === undefined){
            scope.playerRatings.push(pr);
          }
        });
        scope.overlay = false
      }, error => {
          console.log(error);
      });
    }
  },
  created () {
    this.$store.commit('setShowSlideMenu', 'cupfiltersplayed');
    var slugParams = {
      slug: 'playerratings',
      params: ''
    };
    this.getPlayerRatings(slugParams);
  },
  watch: {
      selectedCupId (newVal) {
        console.log(newVal);
        console.log('Cup changed: ' + newVal);
        var slugParams = {
          slug: 'playerratings',
          params: ''
        };
        if(newVal !== 'all'){
          slugParams.params = '&cup_id=' + newVal;
        }
    this.getPlayerRatings(slugParams);
      }
    }
}
</script>